import * as Sentry from '@sentry/react'
import settings from '../../settings'

const { sentryDSN } = settings
class Logger {
  static middleWare(fn, ...args) {
    if (sentryDSN) {
      fn(...args)
    }
  }

  /**
   *
   * @param {object} user
   */
  static setUser(user) {
    Logger.middleWare(Sentry.setUser, user)
  }

  static clearUser() {
    Logger.middleWare(Sentry.configureScope, (scope) => scope.setUser(null))
  }
}

export default Logger
